import { useState, useRef } from 'react';
// react-query
import { useMutation } from '@tanstack/react-query';
// services
import { addSearchProductToFolder } from 'services/folder';
// utils
import { sleep } from 'utils/delay';

export const useAddSearchProductToFolder = () =>
  useMutation({
    mutationFn: addSearchProductToFolder,
  });

export const useHandleAddSearchProductToFolder = () => {
  const folderSelectorRef = useRef();

  const [selectedFolder, setSelectedFolder] = useState();
  const [currentFolderId, setCurrentFolderId] = useState();

  const onSelectFolder = (selectedFolder) => {
    setSelectedFolder(selectedFolder);
  };

  const onBreadcrumbChange = (folderId, _, breadcrumbSelected) => {
    setCurrentFolderId(folderId);
    setSelectedFolder(breadcrumbSelected);
  };

  const onExpandFolder = async (folder) => {
    await sleep(300);
    setCurrentFolderId(folder?.id);
    setSelectedFolder(folder);
  };

  const handleReloadFolderList = (folderId) => {
    folderSelectorRef.current.reloadList(folderId || currentFolderId);
  };

  return {
    folderSelectorRef,
    onSelectFolder,
    onBreadcrumbChange,
    onExpandFolder,
    handleReloadFolderList,
    selectedFolder,
    currentFolderId,
  };
};
